/*
 reportSharingDialog

 This component represents the report sharing dialog.

 */

import $ from 'jquery';
import ko from 'knockout';
import _ from 'lodash';

ko.components.register('reportSharingDialog', {
  viewModel: reportSharingDialog,
  template: {
    element: 'report-sharing-dialog-template'
  }
});


export function reportSharingDialog(params) {

  var self = this;

  params = params || {};

  var data = params && params.data ? params.data : params;

  if (data instanceof reportSharingDialog)
    return data;

  self.loadingData = ko.observable(false);

  self.reportShareData = ko.observable(null);
  self.allReportShareObjects = ko.observableArray([]);

  self.getReportShareDataPromise = data.getReportShareDataPromise;
  self.getAllReportShareObjectsDataPromise = data.getAllReportShareObjectsDataPromise;
  self.saveReportShareDataPromise = data.saveReportShareDataPromise;
  self.onSaveCompletedCallback = data.onSaveCompleted;
  self.onCancelCallback = data.onCancel;

  self.selectedSharesCount = ko.computed(function () {
    return _.isNullOrUndefined(self.reportShareData()) ? 0 : self.reportShareData().reportShares().length;
  });

  self.unselectedSharesCount = ko.computed(function () {
    return _.isNullOrUndefined(self.reportShareData()) ? 0 : self.reportShareData().reportShares().length;
  });

  //Handle a change to the chart series columns
  self.addReportShareData = function (newValue, newData) {
    
    var shares = self.reportShareData().reportShares();
    //self.reportShareData().reportShares.unshift(ko.mapping.fromJS(newData));
    self.reportShareData().reportShares.push(ko.mapping.fromJS(newData));
  }
  
  self.removeReportShare = function (shareObj) {
    
    var type = shareObj.type();
    var id = shareObj.id();

    var newArray = _.filter(self.reportShareData().reportShares(), function (o) {
      var include = o.type() !== type || (o.type() === type && o.id() !== id);
      return include;        
    });

    self.reportShareData().reportShares(newArray);
  }

  self.saveButtonClick = function (item, event) {

    //Get a JS version of the data to send to the API.
    var shareData = ko.mapping.toJS(self.reportShareData());

    //Save to the api
    self.loadingData(true);
    $.when(
		  self.saveReportShareDataPromise(shareData)).then(
		  function (result) {
		    self.loadingData(false);
		    if (!_.isNullOrUndefined(self.onSaveCompletedCallback)) {
		      self.onSaveCompletedCallback();
		    }
		  },
		  function (errorResult) {
		    self.loadingData(false);
		  }
		);
  }

  self.cancelButtonClick = function (item, event) {

    if (!_.isNullOrUndefined(self.onCancelCallback)) {
      self.onCancelCallback.call(null, null);
    }
  }

  self.shareWithDropdownDataSource = function () {

    var deferred = $.Deferred();

    var shareObjects = _.cloneDeep(self.allReportShareObjects());
    
    //Store the current object ids
    var shareData = ko.mapping.toJS(self.reportShareData);
    var currentRoleIds = _.isNullOrUndefined(shareData) ? [] : _.map(_.filter(shareData.reportShares, function(o) { return o.type === "Role"; }), "id");
    var currentUserIds = _.isNullOrUndefined(shareData) ? [] : _.map(_.filter(shareData.reportShares, function (o) { return o.type === "User"; }), "id");

    //Filter out share objects that are already selected
    shareObjects = _.filter(shareObjects, function (o) {
      var keep = true;
      keep = o.type() === "Role" ? _.findIndex(currentRoleIds, function (x) { return x === o.id(); }) === -1 : keep;
      keep = o.type() === "User" ? _.findIndex(currentUserIds, function (x) { return x === o.id(); }) === -1 : keep;
      return keep;
    });

    deferred.resolve(shareObjects);

    return deferred.promise();

  };

  var init = function (initData) {

    //Call the promise functions to get report columns and all columns
    if (!_.isNullOrUndefined(self.getReportShareDataPromise)
      && !_.isNullOrUndefined(self.getAllReportShareObjectsDataPromise)) {

      self.loadingData(true);

      //Go get the report share data
      $.when(
        self.getAllReportShareObjectsDataPromise(),
			  self.getReportShareDataPromise(initData.reportId)).then(
			  function (allShareObjects, shareData) {
			    self.loadingData(false);
			    self.reportShareData(ko.mapping.fromJS(shareData));
			    self.allReportShareObjects(ko.mapping.fromJS(allShareObjects)());
			  },
			  function (errorResult) {
			    self.loadingData(false);
			  }
			);
    }
  }

  init(data);
}